var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36556 8.1821C7.302 9.8288 8.6712 11.198 10.3179 12.1344L11.2024 10.8961C11.4965 10.4845 12.0516 10.3573 12.4956 10.5998C13.9024 11.3683 15.4571 11.8353 17.0789 11.9637C17.599 12.0049 18 12.4389 18 12.9606V17.4234C18 17.9361 17.6122 18.3657 17.1022 18.4181C16.5723 18.4726 16.0377 18.5 15.5 18.5C6.93959 18.5 0 11.5604 0 3C0 2.46227 0.0274201 1.92771 0.0818901 1.39776C0.1343 0.88775 0.56394 0.5 1.07665 0.5H5.53942C6.0611 0.5 6.49513 0.90104 6.5363 1.42109C6.66467 3.04288 7.1317 4.59764 7.9002 6.00444C8.1427 6.4484 8.0155 7.00354 7.6039 7.29757L6.36556 8.1821ZM3.84425 7.5252L5.7442 6.16809C5.20547 5.00514 4.83628 3.77183 4.64727 2.5H2.00907C2.00303 2.66632 2 2.833 2 3C2 10.4558 8.0442 16.5 15.5 16.5C15.667 16.5 15.8337 16.497 16 16.4909V13.8527C14.7282 13.6637 13.4949 13.2945 12.3319 12.7558L10.9748 14.6558C10.4258 14.4425 9.8956 14.1915 9.3874 13.9061L9.3293 13.873C7.3697 12.7587 5.74134 11.1303 4.627 9.1707L4.59394 9.1126C4.30849 8.6044 4.05754 8.0742 3.84425 7.5252Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.21235f54159d81a8179311a8d8d0296d.svg";
export { ForwardRef as ReactComponent };